import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import DataTable from "react-data-table-component";
import DatosSocio from "../../generico/DatosSocio";
import { trackPromise } from "react-promise-tracker";
import authService from "../../../services/login/auth.service";
import FacturaService from "../../../services/consultas/FacturaService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faCheck} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import Popup from "react-popup";

const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true,
};

export default class Factura extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaFactura: [],
      listaPeriodo: [],
      periodoElegido: null,
    };
  }

  notifiPopup = (titulo, mensaje) =>
  Popup.register({
    title: titulo,
    content: mensaje,
    buttons: {
      right: [
        {
          text: "Aceptar",
          className: "success",
          action: function () {
            Popup.close();
          },
        },
      ],
    },
  });
  
  componentDidMount() {
    this.obtenerPeriodo();
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  obtenerPeriodo = () => {
    var lista = [];
    lista.push({
      value: null,
      label: "--Seleccione--",
    });

    var now = new Date();
    var mes = now.getMonth() + 1;
    var anio = now.getFullYear();

    var mesChar = "";
    for (var i = 0; i < 18; i++) {
      if (mes === 0) {
        mes = 12;
        anio = anio - 1;
      }
      mesChar = mes.toString().length === 1 ? "0" + mes : mes;
      lista.push({
        value: mesChar + "/" + anio,
        label: mesChar + "/" + anio,
      });
      mes = mes - 1;
    }
    this.setState({ listaPeriodo: lista });
    return lista;
  };

  dibujarListaFactura() {
    if (this.state.listaFactura.length === 0) {
      return <div></div>;
    }

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <DatosSocio />
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <DataTable
                      noHeader={true}
                      pagination={true}
                      columns={this.getColumn()}
                      data={this.state.listaFactura}
                      dense={true}
                      striped={true}
                      paginationComponentOptions={paginationOptions}
                      noDataComponent="no hay registros para mostrar"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleChangeSelector = (selectedOption) => {
    if (selectedOption === null)
      this.setState({
        listaFactura: [],
        periodoElegido : null
      });
    else {
      this.setState({
        periodoElegido: selectedOption.value,
      });
    }
  };

  getColumn() {
    return [
      {
        name: "Fecha",
        selector: row => row.fecha,
        width: "100px",
      },
      {
        name: "Tipo Documento",
        selector: row => row.tipoDocumento,
        width: "150px",
      },
      {
        name: "Nro. Factura",
        selector: row => row.nroFactura,
        width: "150px",
      },
      {
        name: "Pto. Expedición",
        selector: row => row.ptoExpedicion,
        width: "100px",
      },
      {
        name: "Documento",
        selector: row => row.documento,
        width: "300px",
      },
      {
        cell: (row) => (
          <div>
            <button
              ref={() => this.facturaSel}
              id={
                row.tipoDocumento +
                "#" +
                row.nroFactura +
                "#" +
                row.ptoExpedicion +
                "#" +
                row.fecha
              }
              key={row.id}
              className="btn btn-xs btn-outline-success"
              value={row.id}
              target="_blank"
              onClick={(evt) => {
                this.facturaSel = evt.currentTarget;
                var compos = this.facturaSel.id.split("#");

                this.descargar(
                  compos[0].toLowerCase(),
                  compos[1],
                  compos[2],
                  compos[3]
                );
              }}
            >
              {" "}
              <FontAwesomeIcon icon={faDownload} /> <b>Descargar</b>
            </button>
          </div>
        ),
      },
    ];
  }

  descargar = async (tipo, nroRecibo, nroSerie, fechaEmision) => {
    {/*var listaFactura = []; */} 
    await trackPromise(
      FacturaService.descagarReporte(tipo, nroRecibo, nroSerie, fechaEmision)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");         
        })
        .catch(function (error) {
          console.log(error);
        })
    );

    // this.setState({ listaFactura: listaFactura });
    // return listaFactura;
  };
  obtenerListaFactura = async () => {  
  
    if (this.state.periodoElegido !== null) {
      var anioMes;
      anioMes = this.state.periodoElegido.split("/");

      var listaFactura = [];
      await trackPromise(
        FacturaService.obtenerListadoFacturas(
          parseInt(anioMes[0]),
          parseInt(anioMes[1])
        )
          .then((response) => {
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);

            var resultados = jsonData.resultados;

            if (jsonData.codigoRetorno === "0") {
              for (var i = 0; i < resultados.length; i++) {
                listaFactura.push({
                  fecha: resultados[i].fechaProceso,
                  tipoDocumento: resultados[i].tipoComprobante,
                  nroFactura: resultados[i].nroRecibo,
                  ptoExpedicion: resultados[i].reciboSerie,
                  documento: "0000000045687_001_010_DUPLICADO.PDF",
                });
              }
            } else {
              Popup.queue(this.notifiPopup("Info", jsonData.mensajeRetorno));
              return;
            }
          })
          .catch(function (error) {
            console.log(error);
          })
      );

      this.setState({ listaFactura: listaFactura });
    }
  };

  render() {
    var periodo = this.state.listaPeriodo;

    return (
      <div className="content-wrapper">
        <Titulo texto="Impresión de Facturas" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12" style={{zIndex:1}}>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                      <label className="input-label-bold">Mes *</label>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group"> 
                          <Select
                            required="true"
                            placeholder="-- Seleccione --"
                            onChange={this.handleChangeSelector}
                            options={periodo}
                            isClearable
                            noOptionsMessage={() => "SIN DATOS"}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                      <button
                          className="btn btn-cu-primary"
                          onClick={() => this.obtenerListaFactura()}
                        >
                         <FontAwesomeIcon icon={faCheck} /> Consultar
                        </button>
                      </div>
                    </div>
                  </div>
                  
                </div>
              </div>
            </div>
            {this.dibujarListaFactura()}
          </div>
        </section>
      </div>
    );
  }
}
